import React from 'react';

export default function PageHeader({ eyebrow, title, subtitle, children }) {
  return (
    <section className="bg-hero-tint border-b border-[#E6E9EE]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 md:py-20">
        <div className="max-w-3xl">
          {eyebrow && (
            <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-[#C8922F] font-semibold">
              <span className="h-1.5 w-1.5 rounded-full bg-[#C8922F]" /> {eyebrow}
            </div>
          )}
          <h1 className="mt-2 font-headline text-4xl sm:text-5xl text-[#17352D] leading-[1.05] tracking-[-0.02em]">{title}</h1>
          {subtitle && <p className="mt-4 text-slate-700 text-base md:text-lg max-w-2xl">{subtitle}</p>}
          {children && <div className="mt-6">{children}</div>}
        </div>
      </div>
    </section>
  );
}
